export const getSquadCasesInOtherAreasWithFirstOwner = (formattedUserIdList, limit) => `
SELECT
    Id,
    CaseNumber,
    CreatedDate,
    Imagem_Status__c,
    Status,
    Subject,
    Owner.Name,
    OwnerId
FROM
    Case
WHERE
    First_Owner__c IN (${formattedUserIdList})
    AND OwnerId NOT IN (${formattedUserIdList}, '00G41000002Q39NEAS', '00G41000001ohGLEAY')
    AND Status NOT IN ('Resolvido', 'Fechado', 'Closed as Duplicate', 'Closed', 'Merged')
    ${limit ? `LIMIT ${limit}` : ''}
`;
